var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGif = function SvgGif(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gif_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    d: "M18.75 31.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5M21.805 36.668c-.665.997.05 2.332 1.248 2.332h6.394c1.198 0 1.913-1.335 1.248-2.332l-3.197-4.796a1.5 1.5 0 0 0-2.496 0zM37.5 24H33a1.5 1.5 0 0 0-1.5 1.5V30a1.5 1.5 0 0 0 1.5 1.5h4.5A1.5 1.5 0 0 0 39 30v-4.5a1.5 1.5 0 0 0-1.5-1.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#18B5C7",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.386 13.96a1 1 0 0 0-.146-.325.9.9 0 0 0-.238-.243 1 1 0 0 0-.322-.15 1.4 1.4 0 0 0-.398-.053q-.436 0-.756.211-.316.211-.49.616-.172.4-.172.975 0 .577.167.985.167.407.483.62.316.215.768.215.398 0 .673-.13a.95.95 0 0 0 .422-.371q.144-.241.144-.566l.27.032h-1.46V14.72h2.587v.794q0 .806-.342 1.38a2.3 2.3 0 0 1-.938.881q-.594.308-1.368.308-.858 0-1.509-.372a2.6 2.6 0 0 1-1.014-1.06q-.363-.691-.363-1.641 0-.738.22-1.31a2.647 2.647 0 0 1 1.526-1.576 3 3 0 0 1 1.122-.205q.522 0 .97.15.451.149.797.421.348.273.565.648t.27.823zM17.223 12v6h-1.45v-6zm.91 6v-6h4.096v1.178h-2.645v1.23h2.385v1.18h-2.385V18z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gif_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgGif;